module.exports = __webpack_public_path__ + "img/income-bg.9273b6ee.png";